import React, { Component } from 'react';
import { Table, Row, DatePicker, Button } from "antd";
import moment from "moment";
import FileSaver from "file-saver";

const { MonthPicker } = DatePicker;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class Detail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            dataTitle: [],
            isDay: window.location.hash.includes('day'),
            date: window.location.hash.includes('day') ? moment().format('YYYY-MM-DD') : moment().subtract(1, 'month').format('YYYY-MM'),
            loading: true,
            dateData: [],
            group: {},

        }
    }

    componentDidMount() {
        let date = Number(this.state.date || "0");
        let dateData = [];
        let len = date - 2018 + 3;
        for (let i = 0; i < len; i++) {
            dateData.push((2018 + i).toString())
        }
        this.setState({ dateData });
        this.getData(this.state.date);
    }

    getData = (date) => {
        this.setState({ loading: true });
        const day = moment(date).format('D');
        const url = `/getECompared?id=${this.props.match.params.id}&day=${day}&year=${moment(date).format('YYYY')}&month=${moment(date).format('MM')}&week=${moment(date).format('w')}`;
        fetch(url, { credentials: 'include' }).then(x => x.json()).then(x => {

            let data = x.data.table || [];
            let obj = {
                name: '总计',
                id: '--',
            };
            (x.data.compared || []).forEach(item => {
                obj[item.dataIndex] = data.reduce((a, b) => {
                    a += Number(b[item.dataIndex] || "0") || 0;
                    return a
                }, 0).toFixed(3) || "";
            });
            data.push({
                ...obj,
            });
            this.setState({
                data,
                dataTitle: x.data.compared || [],
                loading: false,
                group: x.data.group || {}
            });
        }).catch(err => {
            console.error(err);
        })
    }

    getText = (text, index, type, totalIndex) => {
        switch (type) {
            case 'number':
                return (
                    <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''}`}>
                        {Number(text || '0') < 0 ?
                            <span style={{ color: "red" }}>
                                ({Math.abs(Number(text || "0")).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                            </span>
                            :
                            Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                        }
                    </div>
                )
                break;
            case 'percent':
                return (
                    <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''} `}>
                        {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                    </div>
                )
                break;
            case 'text':
                return (
                    <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "left", whiteSpace: "inherit" }}>
                        {text == 0 ? '' : text}
                    </div>
                )
                break;

            default:
                return (
                    <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "left", whiteSpace: "inherit" }}>
                        {text == 0 ? '-' : text}
                    </div>
                )
                break;
        }
    }

    downloadSG = () => {
        const innerHtml = `
          <caption>${this.state.group.name || ""}</caption>
          ${document.getElementById('table').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(this.state.group.name || "") + (this.state.date)}.xls`);
        this.setState({ print: false });
    }

    render() {
        const { data, dataTitle, isDay } = this.state;
        const totalIndex = [data.length - 1];
        let columns = dataTitle.map(x => {
            let title = x.title.split(',');
            let dataCloumns = {};
            switch (title.length) {
                case 1:
                    dataCloumns = {
                        title: <span dangerouslySetInnerHTML={{ __html: x.name }}></span>,
                        children: [{
                            title: <span dangerouslySetInnerHTML={{ __html: title[0] }}></span>,
                            dataIndex: x.dataIndex,
                            key: x.dataIndex,
                            align: "center",
                            width: 150,
                            sorter: (a, b) => (a[x.dataIndex] - b[x.dataIndex]),
                            render: (text, record, index) => {
                                return this.getText(text, index, x.type, totalIndex)
                            }
                        }],

                    }
                    break;
                case 2:
                    dataCloumns = {
                        title: x.name,
                        children: [{
                            title: <span dangerouslySetInnerHTML={{ __html: title[0] }}></span>,
                            children: [{
                                title: <span dangerouslySetInnerHTML={{ __html: title[1] }}></span>,
                                dataIndex: x.dataIndex,
                                key: x.dataIndex,
                                align: "center",
                                width: 150,
                                sorter: (a, b) => (a[x.dataIndex] - b[x.dataIndex]),
                                render: (text, record, index) => {
                                    return this.getText(text, index, x.type, totalIndex)
                                }
                            }],

                        }],
                    }
                    break;
                case 3:
                    dataCloumns = {
                        title: x.name,
                        children: [{
                            title: <span dangerouslySetInnerHTML={{ __html: title[0] }}></span>,
                            children: [{
                                title: <span dangerouslySetInnerHTML={{ __html: title[1] }}></span>,
                                children: [{
                                    title: <span dangerouslySetInnerHTML={{ __html: title[2] }}></span>,
                                    dataIndex: x.dataIndex,
                                    key: x.dataIndex,
                                    align: "center",
                                    width: 150,
                                    sorter: (a, b) => (a[x.dataIndex] - b[x.dataIndex]),
                                    render: (text, record, index) => {
                                        return this.getText(text, index, x.type, totalIndex)
                                    }
                                }],

                            }],
                        }],
                    }
                    break;
                case 4:
                    dataCloumns = {
                        title: x.name,
                        children: [{
                            title: <span dangerouslySetInnerHTML={{ __html: title[0] }}></span>,
                            children: [{
                                title: <span dangerouslySetInnerHTML={{ __html: title[1] }}></span>,
                                children: [{
                                    title: <span dangerouslySetInnerHTML={{ __html: title[2] }}></span>,
                                    children: [{
                                        title: <span dangerouslySetInnerHTML={{ __html: title[3] }}></span>,
                                        dataIndex: x.dataIndex,
                                        key: x.dataIndex,
                                        align: "center",
                                        width: 150,
                                        sorter: (a, b) => (a[x.dataIndex] - b[x.dataIndex]),
                                        render: (text, record, index) => {
                                            return this.getText(text, index, x.type, totalIndex)
                                        }
                                    }],

                                }],
                            }],
                        }],
                    }
                    break;
                default:
                    break;
            }
            return dataCloumns
        });
        let width = document.body.offsetWidth - dataTitle.length * 150 > 350 ? document.body.offsetWidth - dataTitle.length * 150 : 350;

        columns.unshift({
            title: '酒店名称',
            dataIndex: 'name',
            align: "center",
            width: dataTitle.length <= 6 ? 350 : width,
            fixed: dataTitle.length <= 6 ? '' : this.state.print ? "" : "left",
            render: (text, record, index) => {
                return this.getText(text, index, '', totalIndex)
            }
        });
        return (
            <div className="table7_1_1 table12">
                <Row className="title" id="table3_3_3" style={{ width: this.state.print ? 2040 : 'auto' }}>
                    <Row>
                        Executive Summary Report 月度经营报告  <br /> <span style={{ fontSize: 22 }}>{this.state.group.name || ""}</span>
                    </Row>
                    <Row className="table-month">
                        {
                            !isDay && <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getData(str)
                                }}
                            />
                        }

                        {isDay && <DatePicker
                            placeholder="请选择年月"
                            defaultValue={moment(this.state.date, "YYYY-MM-DD")}
                            format="YYYY-MM-DD"
                            onChange={(date, str) => {
                                const d = moment(date).format('YYYY-MM-DD');
                                this.setState({
                                    date: d,
                                    data: [],
                                    loading: true
                                });
                                this.getData(d)
                            }}
                        />
                        }
                    </Row>
                    <Table
                        id='table'
                        columns={columns}
                        dataSource={data}
                        bordered
                        size="middle"
                        className="content"
                        pagination={false}
                        scroll={this.state.print ? {} : { y: 520, x: dataTitle.length * 150 + (dataTitle.length <= 6 ? 350 : width) }}
                        loading={this.state.loading}
                        rowKey={item => item.id}
                    />
                </Row>
                <Row className="table-footer-btn">
                    <Button
                        type="primary"
                        style={{ marginRight: 15 }}
                        onClick={() => {
                            this.props.history.goBack();
                        }}
                    >返回</Button>
                    <Button
                        type="primary"
                        onClick={() => {
                            this.setState({ print: true }, () => {
                                this.downloadSG();
                            });
                        }}
                        loading={this.state.print}
                    >导出Excel</Button>
                </Row>

            </div>
        );
    }
}

export default Detail;


// WEBPACK FOOTER //
// ./src/components/compared/Detail.js